import React, {Component} from 'react'
import {Col, Form, InputNumber, Row, Select, TimePicker} from 'antd'
import {strVal} from '../../../../../../../modules/Utils'
import OvertimeSelect from '../../../../../../../elements/Select/Employee/OverTime'
import moment from 'moment'

const FormItem = Form.Item
const {Option} = Select

class WorkingConditions extends Component {
  render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }
    const {getFieldDecorator} = this.props.form
    const {workOrder} = this.props
    return (
      <div>
        <Form layout="horizontal">
          <Row>
            <Col span={12}>
              <FormItem label="Full Day Working Hours
" {...formItemLayout}>
                {getFieldDecorator('hours.fullDay', {
                  initialValue: strVal(workOrder, 'hours.fullDay'),
                  rules: [
                    {
                      required: true,
                      message: "Full Day Working Hours can't be empty ",
                    },
                  ],
                })(
                  <InputNumber
                    style={{width: '100%'}}
                    placeholder="Full Day Working Hours
"
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Half Day Working Hours" {...formItemLayout}>
                {getFieldDecorator('hours.halfDay', {
                  initialValue: strVal(workOrder, 'hours.halfDay'),
                  rules: [
                    {
                      required: true,
                      message: "Half Day Working Hours can't be empty ",
                    },
                  ],
                })(
                  <InputNumber
                    style={{width: '100%'}}
                    placeholder="Half Day Working Hours"
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Maximum Hours Per Week" {...formItemLayout}>
                {getFieldDecorator('hours.max', {
                  initialValue: strVal(workOrder, 'hours.max'),
                  rules: [
                    {
                      required: true,
                      message: "Maximum Hours Per Week can't be empty ",
                    },
                  ],
                })(
                  <InputNumber
                    style={{width: '100%'}}
                    placeholder="Maximum Hours Per Week"
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Overtime" {...formItemLayout}>
                {getFieldDecorator('overtime', {
                  initialValue: workOrder.overtime,
                  rules: [
                    {
                      required: true,
                      message: "Overtime can't be empty ",
                    },
                  ],
                })(<OvertimeSelect placeholder="Select Overtime .. " />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Travel Days" {...formItemLayout}>
                {getFieldDecorator('travelDays', {
                  initialValue: workOrder.travelDays,
                  rules: [
                    {
                      required: true,
                      message: "Travel Days can't be empty ",
                    },
                  ],
                })(<OvertimeSelect placeholder="Select Travel Days .. " />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Rostered Day Off" {...formItemLayout}>
                {getFieldDecorator('rosteredDayOff', {
                  initialValue: workOrder.rosteredDayOff,
                  rules: [
                    {
                      required: true,
                      message: "Rostered Day Off can't be empty ",
                    },
                  ],
                })(
                  <OvertimeSelect placeholder="Select Rostered Day Off .. " />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Normal Start Time
" {...formItemLayout}>
                {getFieldDecorator('startTime', {
                  initialValue:
                    workOrder.startTime && moment(workOrder.startTime, 'HH:mm'),
                  rules: [
                    {
                      required: true,
                      message: "Normal Start Time can't be empty ",
                    },
                  ],
                })(
                  <TimePicker
                    style={{width: '100%'}}
                    format="HH:mm"
                    placeholder="Normal Start Time Hours
"
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

export default Form.create()(WorkingConditions)
